import { Cotizacion } from "@/shared/types/cotizacion";
import { Moneda } from "@/shared/types/moneda";

export interface FormItem {
    codigo: string;
    descripcion: string;
    cantidad: number;
    precio: number;
    iva: "exenta" | "5" | "10";
    unidadMedida: number;
    dDncpG?: string;
    dDncpE?: string;
    cdcAnticipo?: string;
}

export interface DEItem {
    dCodInt: string;
    dDesProSer: string;
    cUniMed: number;
    dCantProSer: number;
    dPUniProSer: number;
    dTotBruOpeItem: number;
    dTotOpeItem: number;
    iAfecIVA?: number;
    dPropIVA?: number;
    dTasaIVA?: number;
    dBasGravIVA?: number;
    dLiqIVAItem?: number;
    dBasExe?: number;
    dDncpG?: string;
    dDncpE?: string;
    dCDCAnticipo?: string;
}

export type MapDEItemOptions = {
    omitIVA?: boolean;
    dTiCam?: number;
    monedaBase?: Moneda;
    monedaOperacion?: Moneda;
    cotizacion?: Cotizacion;
};

/*
  Mapea un item del formulario al formato del backend
 */
function mapFormItemToDEItem(item: FormItem, options?: MapDEItemOptions): DEItem {
    let precio = item.precio;

    if (options?.monedaBase?.simbolo == "PYG" && options?.monedaOperacion?.simbolo !== "PYG") {
        precio = item.precio / (options.dTiCam ?? 1);

    } else if (options?.monedaBase?.simbolo !== "PYG") {
        if (options?.monedaOperacion?.simbolo === "PYG") {
            precio = item.precio * (options.dTiCam ?? 1);

        } else if (options?.monedaBase?.simbolo !== options?.monedaOperacion?.simbolo) {
            let cotizacion = options?.cotizacion?.cotizacionItems.find(c => c.monedaId === options.monedaOperacion?.id);
            precio = item.precio * (cotizacion ? (1 / cotizacion.monedaBaseRelacion) : 1);
        }
    }

    const omitIVA = options?.omitIVA;
    const esExenta = item.iva === "exenta";
    const tasaIVA = item.iva === "exenta" ? 0 : parseInt(item.iva);
    const subtotal = item.cantidad * precio;

    return {
        dCodInt: item.codigo,
        dDesProSer: item.descripcion,
        cUniMed: item.unidadMedida,
        dCantProSer: item.cantidad,
        dPUniProSer: precio,
        dTotBruOpeItem: subtotal,
        dTotOpeItem: subtotal,
        ...(omitIVA ? {} : {
            iAfecIVA: esExenta ? 3 : 1, // 1=Gravada, 3=Exenta
            dPropIVA: esExenta ? 0 : 100,
            dTasaIVA: tasaIVA, // tasa (exenta, 5, o 10)
            dBasGravIVA: esExenta ? 0 : subtotal,
            dLiqIVAItem: esExenta ? 0 : (subtotal * (tasaIVA / 100)),
            dBasExe: esExenta ? subtotal : 0
        }),
        dDncpG: item.dDncpG || undefined,
        dDncpE: item.dDncpE || undefined,
        dCDCAnticipo: item.cdcAnticipo || undefined,
    };
}

export function mapFormItemsToDEItems(items: FormItem[], options?: MapDEItemOptions): DEItem[] {
    return items.map((item) => mapFormItemToDEItem(item, options));
}
